var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98676 5.17505C6.94223 5.17505 3.81918 6.93716 1.36058 10.4614C1.29041 10.5631 1.25195 10.6833 1.25007 10.8068C1.24819 10.9304 1.28298 11.0517 1.35004 11.1555C3.2391 14.1125 6.32035 16.425 9.98676 16.425C13.6133 16.425 16.7578 14.1055 18.6504 11.1418C18.7159 11.0401 18.7507 10.9216 18.7507 10.8006C18.7507 10.6796 18.7159 10.5612 18.6504 10.4594C16.7536 7.52974 13.586 5.17505 9.98676 5.17505Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.925C11.7259 13.925 13.125 12.5259 13.125 10.8C13.125 9.07416 11.7259 7.67505 10 7.67505C8.27411 7.67505 6.875 9.07416 6.875 10.8C6.875 12.5259 8.27411 13.925 10 13.925Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeMini);
export default __webpack_public_path__ + "static/media/eye_mini.38e25e2ca0a75015399fc745d8f918c9.svg";
export { ForwardRef as ReactComponent };